import { c as _c } from "react/compiler-runtime";
import { i18n as uiI18n, loadLangBundle as uiLoadLangBundle, LocaleEnum, LocaleProvider as UiLocaleProvider, getLanguageCodeByLocale } from '@systemeio/ui';
import { i18n as fileManagerI18n, loadLangBundle as fileManagerLoadLangBundle, LocaleProvider as FileManagerLocaleProvider } from '@systemeio/file-manager';
import { i18n as tipTapI18n, LocaleProvider as TipTapLocaleProvider, loadLangBundle as tipTapLoadLangBundle } from '@systemeio/tip-tap';
import { i18n as utilI18n, loadLangBundle as utilLoadLangBundle, LocaleProvider as UtilLocaleProvider } from '@systemeio/util';
import { useTranslation } from 'next-i18next/pages';
import { PropsWithChildren } from 'react';
const defaultLocale = LocaleEnum.ENGLISH;
const defaultLanguageCode = getLanguageCodeByLocale(defaultLocale);
export function LocaleProviders(t0) {
  const $ = _c(12);
  const {
    children
  } = t0;
  const {
    i18n
  } = useTranslation();
  const languageCode = (i18n.resolvedLanguage ?? i18n.language ?? defaultLanguageCode) as typeof defaultLanguageCode;
  let t1;
  if ($[0] !== children || $[1] !== languageCode) {
    t1 = <TipTapLocaleProvider i18n={tipTapI18n} languageCode={languageCode} loadLangBundle={tipTapLoadLangBundle}>{children}</TipTapLocaleProvider>;
    $[0] = children;
    $[1] = languageCode;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== languageCode || $[4] !== t1) {
    t2 = <FileManagerLocaleProvider i18n={fileManagerI18n} languageCode={languageCode} loadLangBundle={fileManagerLoadLangBundle}>{t1}</FileManagerLocaleProvider>;
    $[3] = languageCode;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== languageCode || $[7] !== t2) {
    t3 = <UiLocaleProvider i18n={uiI18n} languageCode={languageCode} loadLangBundle={uiLoadLangBundle}>{t2}</UiLocaleProvider>;
    $[6] = languageCode;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== languageCode || $[10] !== t3) {
    t4 = <UtilLocaleProvider i18n={utilI18n} languageCode={languageCode} loadLangBundle={utilLoadLangBundle}>{t3}</UtilLocaleProvider>;
    $[9] = languageCode;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}